import { api } from '../../api/endpoints'
import type { ChannelSummary } from '../../api/types'
import { db } from '../../db/db'
import { summaryToRow } from '../../sync/applyEvents'
import { syncAll } from '../../sync/syncEngine'
import { existingConversationWith } from './recentContacts'

const ORIGIN_VERSION = '0.0000000000000000'

/**
 * Store a channel returned by create/DM endpoints so it can be opened immediately. The row starts
 * at the origin version, so the next sync replays its events (delta) or sends a snapshot.
 */
export async function storeNewChannel(summary: ChannelSummary): Promise<void> {
  const existing = await db.channels.get(summary.id)
  if (!existing) {
    await db.channels.put({ ...summaryToRow(summary, undefined), version: ORIGIN_VERSION, headSeq: 0, lastMessage: summary.lastMessage })
  }
  void syncAll()
}

/**
 * The conversation with one person or bot: the one this phone already has, straight away and offline, or else the
 * server's (which hands back an existing one rather than making a second). Returns its id.
 */
export async function openDirectMessage(meId: string, userId: string): Promise<string> {
  const existing = await existingConversationWith(meId, userId)
  if (existing) return existing
  const summary = await api.createDm([userId])
  await storeNewChannel(summary)
  return summary.id
}
